exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bajas_cobranza_ver_detalle a {\n  width: 400px;\n}\n", ""]);

// exports
